import { render } from "./UsersSlot.vue?vue&type=template&id=343b06c2&scoped=true"
import script from "./UsersSlot.vue?vue&type=script&lang=js"
export * from "./UsersSlot.vue?vue&type=script&lang=js"

import "./UsersSlot.vue?vue&type=style&index=0&id=343b06c2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-343b06c2"]])

export default __exports__